/**
 * Calculates the start and end boundaries of a week (Monday to Sunday).
 *
 * @param offset - Number of weeks to offset from the current week.
 *                 0 = current week, 1 = next week, -1 = previous week
 * @returns Object containing the week's start date (Monday at 00:00),
 *          end date (Sunday at 23:59:59.999), and whether the week
 *          extends beyond the current moment
 *
 * @example
 * // Get current week
 * const currentWeek = getWeekBoundaries()
 *
 * // Get next week
 * const nextWeek = getWeekBoundaries(1)
 *
 * // Get previous week
 * const lastWeek = getWeekBoundaries(-1)
 */
export function getWeekBoundaries(offset = 0) {
  const now = new Date()
  const currentDay = now.getDay()

  // Calculate Monday as the start of the week (00:00:00.000)
  const startOfWeek = new Date(now)
  const daysFromMonday = currentDay === 0 ? 6 : currentDay - 1
  startOfWeek.setDate(now.getDate() - daysFromMonday + offset * 7)
  startOfWeek.setHours(0, 0, 0, 0)

  // Calculate Sunday as the end of the week (23:59:59.999)
  const endOfWeek = new Date(startOfWeek)
  endOfWeek.setDate(startOfWeek.getDate() + 6)
  endOfWeek.setHours(23, 59, 59, 999)

  // Check if any part of the week extends beyond the current moment
  const isInFuture = endOfWeek > now

  return {
    startOfWeek,
    endOfWeek,
    isInFuture,
  }
}
